import { Fab } from '@mui/material'
import { KeyboardArrowUp } from '@mui/icons-material'
import { useEffect, useState } from 'react'

interface ILoaderProps {
  onClick?: () => void
}

const ScrollToTopCornerButton: React.FC<ILoaderProps> = (props) => {
    const { onClick } = props
    const [showScrollToTop, setShowScrollToTop] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop
            setShowScrollToTop(scrollTop > 300) // Show button after scrolling 300px
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

  return (
    <>
    {showScrollToTop && (
    <Fab
        color="primary"
        size="medium"
        onClick={onClick ? onClick : scrollToTop}
        sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1000,
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
            '&:hover': {
                transform: 'scale(1.05)',
                transition: 'transform 0.2s ease-in-out'
            }
        }}
        aria-label="scroll to top"
    >
        <KeyboardArrowUp />
    </Fab>
    )}
    </>
  )
}

export default ScrollToTopCornerButton
